import { useIntl } from '@weenat/wintl'
import Badge from 'app/src/kit/Badge'
import Icons from 'app/src/kit/Icons'
import Text from 'app/src/kit/Text'

interface MissingDataBadgeProps {
  count: number
  timeUnit: 'days' | 'hours'
}

/**
 * Info badge to inform about missing data on cumulative sums
 */
const MissingDataBadge: FC<MissingDataBadgeProps> = ({ count, timeUnit }) => {
  const { t } = useIntl()

  const label = t(
    timeUnit === 'hours'
      ? 'help.cumulative_sum_missing_hours_short'
      : 'help.cumulative_sum_missing_days_short',
    { missingDays: count }
  )

  return (
    <Badge
      $backgroundColor='feedback.error.200'
      $borderColor='feedback.error.800'
      $borderRadius='sm'
      $px='sm'
      $py='xs'
      $gap='xs'
    >
      <Icons.AlertTriangle $size='md' $color='feedback.error.500' />
      <Text $fontSize='sm' $color='feedback.error.800'>
        {label}
      </Text>
    </Badge>
  )
}

export default MissingDataBadge
